import { render, staticRenderFns } from "./EWTrxActivityTypeLogList.vue?vue&type=template&id=2515eb44&"
import script from "./EWTrxActivityTypeLogList.vue?vue&type=script&lang=js&"
export * from "./EWTrxActivityTypeLogList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports